<template>
  <div class="floating-widget">
    <div class="widget-list">
      <div class="widget-item" @click="toHref('aboutUs?id=3613041261525775467', '_blank')" :class="[`wui-hover-color-${themeColor}`]">
        <img src="@/assets/images/common/gywm.png" width="24px" height="24px" alt="">
        <div>关于我们</div>
      </div>
      <div class="widget-item" @click="toHref('https://mall.nfstzx.com/industry/dataAcquisitionForm?id=7120700956034836512&ltype=plat_bigdata', '_blank')" :class="[`wui-hover-color-${themeColor}`]">
        <img src="@/assets/images/common/lxwm.png" width="22px" height="19px" alt="">
        <div>我要加盟</div>
      </div>
      <div class="widget-item" :class="[`wui-hover-color-${themeColor}`]">
        <img src="@/assets/images/common/lxdh.png" width="20px" height="20px" alt="">
        <el-popover class="box-item" content="Left Bottom prompts info" placement="left" :width="200" v-if="platInfo.tel">
          <template #reference>
            联系电话
          </template>
          <div class="box-item-content">
            <div>{{ platInfo.tel }}</div>
            <div :class="[`wui-hover-color-${themeColor}`,'cursor-pointer']" @click="copyPhoneNumber">点击复制</div>
          </div>
        </el-popover>
        <div v-else>联系电话</div>
      </div>
      <div class="widget-item" @click="handleQRCode" :class="[`wui-hover-color-${themeColor}`]">
        <el-popover class="box-item" content="Left Bottom prompts info" placement="left" :width="200" v-if="platInfo.gzh">
          <template #reference>
            扫码关注
          </template>
          <img :src="commenUrl+platInfo.gzh" width="170px" height="170px" alt="二维码">
        </el-popover>
        <div v-else>扫码关注</div>
      </div>
    </div>
    <div class="ArrowUpBold" @click="handleScrollToTop" :class="[`wui-hover-color-${themeColor}`]"
      v-show="scrollY > 100">
      <el-icon>
        <ArrowUpBold />
      </el-icon>
    </div>
    <!-- <div class="qrcode-popup" v-show="showQRCode">
        <img src="@/assets/images/common/lxdh.png" width="120px" height="120px" alt="二维码">
      </div> -->
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, getCurrentInstance } from 'vue';
import { ArrowUpBold } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus';
const props = defineProps({
  themeColor: {
    type: String,
    default: 'blue'
  },
  platInfo: {
      type: Object,
      default: {}
  }
})

const { proxy } = getCurrentInstance();
const showQRCode = ref(false);
const scrollY = ref(0);
// 监听滚动事件
const handleScroll = () => {
  scrollY.value = window.scrollY || document.documentElement.scrollTop;
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
const handleQRCode = () => {
  showQRCode.value = !showQRCode.value;
};

const handleScrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
    duration: 1000
  });
};
//复制联系电话
const copyPhoneNumber = async (text) => {
  try {
    await navigator.clipboard.writeText(props.platInfo.tel);
    ElMessage.success('复制成功');
  } catch (err) {
    ElMessage.error('复制失败，请重试');
    console.error('复制失败:', err);
  }
};
// 判断是否为完整URL
const isFullUrl = (url) => {
    return /^https?:\/\//.test(url);
};
// 执行跳转
const toHref = (url, type) => {
    if (!url) {
        return;
    }
    if (type !== '内链') {
        type = '_blank'
    }
    if (type === '_blank') {
        // 新标签页打开
        proxy.tool.openWindow(url);
    } else if (isFullUrl(url)) {
        // 完整URL，使用页面跳转
        window.location.href = url;
    } else {
        // 相对路径，使用路由跳转
        router.push(url);
    }
};
</script>

<style scoped lang="less">
/* 新增悬浮组件样式 */
.floating-widget {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  height: 310px;
  .widget-list {
    background: #fff;
    border-radius: 23px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 999;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 200px;
    /* 固定高度避免布局抖动 */
  }

  .widget-item {
    margin: 0 9px;
    /* 调整内边距使垂直间距更均匀 */
    text-align: center;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    transition: background-color 0.3s;
    width: 28px;
    line-height: 20px;

    img {
      margin-bottom: 5px;
    }

    &:hover {
      // background-color: #f5f5f5;
    }

    &:not(:last-child) {
      border-bottom: 1px solid #eee;
      padding-bottom: 10px;
      margin-bottom: 12px;
    }

    &:last-child {
      padding-bottom: 14px;
    }

    &:first-child {
      padding-top: 14px;
    }
  }

  .ArrowUpBold {
    margin-top: 10px;
    background-color: #fff;
    border-radius: 23px;
    width: 46px;
    height: 46px;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
}
.cursor-pointer{
  cursor: pointer;
}
.box-item-content{
  padding: 5px 0;
  text-align: center;
}
</style>